import React, { SetStateAction } from 'react';
import { CellContext } from '@tanstack/react-table';

import Actions from '@components/common/Actions';
import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import { dateFormattingWithSlash } from '@utils/date';
import { getDateWithoutOffset } from '@utils/kpi-utils/date';

import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';
import { EVesDataColumns } from '@interfaces/vesData/vesData';

interface IProps {
	setCurrentVesDataId: React.Dispatch<SetStateAction<string | undefined>>;
	setIsVesRawDataModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const getVesColumns = ({ setCurrentVesDataId, setIsVesRawDataModalOpen }: IProps) => [
	{
		header: EVesDataColumns.networkElementName.title,
		accessorKey: EVesDataColumns.networkElementName.key,
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: EVesDataColumns.source.title,
		accessorKey: EVesDataColumns.source.key,
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: EVesDataColumns.middlewareName.title,
		accessorKey: EVesDataColumns.middlewareName.key,
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: EVesDataColumns.sequence.title,
		accessorKey: EVesDataColumns.sequence.key,
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: EVesDataColumns.fileName.title,
		accessorKey: EVesDataColumns.fileName.key,
		cell: ({ getValue }: CellContext<any, any>) => <AdaptiveTableCell text={getValue()} />,
	},
	{
		header: EVesDataColumns.eventTime.title,
		accessorKey: EVesDataColumns.eventTime.key,
		cell: ({ getValue }: CellContext<IMiddlewareSMO, any>) => {
			const value = getValue();
			const dateWithoutOffset = getDateWithoutOffset(value);
			const date = dateFormattingWithSlash(dateWithoutOffset);

			return value && <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Actions',
		accessorKey: 'actions',
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			const { original } = row;
			const { id } = original;

			const handleOpenEvent = () => {
				setCurrentVesDataId(id);
				setIsVesRawDataModalOpen(true);
			};

			return (
				<Actions
					isOpenModal
					openModalHandler={handleOpenEvent}
				/>
			);
		},
	},
];
